import { render } from "./dynamicForm.vue?vue&type=template&id=ae10e122&scoped=true"
import script from "./dynamicForm.vue?vue&type=script&lang=js"
export * from "./dynamicForm.vue?vue&type=script&lang=js"

import "./dynamicForm.vue?vue&type=style&index=0&id=ae10e122&scoped=true&lang=scss"

import exportComponent from "D:\\Project\\website-shuziyun\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ae10e122"]])

export default __exports__